module.exports = __webpack_public_path__ + "img/6-4.394ae479.png";